// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"SubmittedPurchaseOrders_sectionWrapper__c0LLc"};